import { create } from 'zustand'

// Modals are just references
type Modal = {
    id: string
}

// We only need the actual component when adding them
type ModalWithComponent = Modal & {
    component: React.ReactNode
}

type ModalStackStore = {
    modals: ModalWithComponent[]
    addModal: (modal: ModalWithComponent) => void
    removeModal: (modal: Modal) => void
    modalIsOpen: (modal: Modal) => boolean
}

export const useModalStackStore = create<ModalStackStore>((set, get) => ({
    modals: [],
    addModal: (modal) => {
        set((state) => ({
            modals: [...state.modals, modal],
        }))
    },
    removeModal: (modal) => {
        set((state) => ({
            modals: state.modals.filter((m) => m.id !== modal.id),
        }))
    },
    modalIsOpen: (modal) => get().modals.some((m) => m.id === modal.id),
}))

export default useModalStackStore
